import useNavigation from './useNavigation';

interface IParams {
  start_date?: string;
  end_date?: string;
  time_range_type?: string;
  equipment_condition?: string;
  equipment_id?: string;
}

export default function useEquipmentInspectionsNavigation() {
  return useNavigation<IParams>('/equipment/inspections-report');
}
